<template>
  <div>
    <headerNav title="我的个人微信二维码" />
    <div style="margin-top: 30px; text-align: center">
      <p style="padding: 5px 30px;font-size:14px">
        您的下级零售客户下单付款后将会自动展示您的二维码,方便下级与您联系
      </p>
      <img
        :src="$baseurl + qrcodeimgurl"
        style="width: 300px; height: 300px"
        v-if="qrcodeimgurl"
      />
      <p v-if="uploadrecord.id" style="font-size:14px">等待后台管理审核</p>
     <div>
          <van-uploader
        upload-text="上传二维码图片"
        :max-count="1"
        :after-read="afterRead"
        accept="image/*"
      >
      </van-uploader>
     </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      qrcodeimgurl: "",
      uploadrecord: {},
    };
  },
  methods: {
    afterRead(file) {
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file); //接口需要传的参数
      this.ajax.post("/File/GatherImageUploadPost", formData).then((x) => {
        var imgurl = x.result.data[0];
        this.qrcodeimgurl = imgurl;
        console.log("打印图片路径:" + this.qrcodeimgurl);

        this.ajax
          .post("/api/services/app/PhoneUser/UploadWxQrcode?qrcode="+this.qrcodeimgurl)
          .then((res) => {
              this.init();
          });
      });
    },
    init() {
      this.ajax.post("/api/services/app/PhoneUser/QueryMyWxQrcodeUpRecord").then((x) => {
        this.uploadrecord = x.result;
        if (this.uploadrecord.id) {
          this.qrcodeimgurl = this.uploadrecord.qrCodeUrl;
        } else {
          this.qrcodeimgurl = this.abp.userInfo.qrCodeUrl;
        }
      });
    },
  },
  created() {
    this.init();
  },
};
</script>
